import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/helpers";
import { ReactNode } from "react";
import CenteredArea from "./centered-area";
import StatusText from "./status-text";
type ErrorFallbackProps = {
  className?: string;
  children?: ReactNode;
};
export default function ErrorFallback(t0) {
  const $ = _c(7);
  const {
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("mx-auto my-8 min-h-24 max-w-5xl border-2 border-dashed", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <StatusText variant="error">{children}</StatusText>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <CenteredArea className={t1}>{t2}</CenteredArea>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

// Recycled

// 28 May 2025

// "Could not load the content"